module.exports = __webpack_public_path__ + "img/preview.e4eec715.webp";